import { LSFetch } from "../helpers";

export const getCategories = (language = "en") => {
  return LSFetch.get("/category/group", { params: { language } });
};
